import React, {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { invitationApi, resetPasswordApi } from "api/services/authentication";
import { toast, Bounce } from "react-toastify";
import { useSearchParams } from "react-router-dom"; // Get query params

const ResetPassword = () => {
    const navigate = useNavigate();
// Validation Schema using Yup
const schema = yup.object().shape({
    password: yup.string().min(5, "Password must be at least 5 characters").required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [userData, setUserData] = useState("");

    // Get email & token from URL
    useEffect(() => {
        // setEmail(searchParams.get("email") || "");
        let token = searchParams.get("token") || ""
        setToken(token);
        let payload = {token}
        postTokenData(payload, "get")
      }, [searchParams]);

      const postTokenData = (payload, type) => {
        invitationApi(payload).then(response=>{
            if(type=="get"){
                setUserData(response.data?.data)
            }else{
                toast.success(response?.data?.message||"Invitation accepted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    transition: Bounce,
                    });
                    navigate("/login")
            }
        }).catch(err=>{
            console.log(err, "LLLL")
            const error = err.response?.data?.error || "Failed to accept invite"
            toast.error(error, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              transition: Bounce,
              });
        })
      }

  const onSubmit =  (data) => {
    const payload = {
        token,
        password: data.password,
        accept_invitation:true
      };
      postTokenData(payload,"post" )

  };


  const acceptInvitation = (event) => {

    event.preventDefault(); // Prevents page refresh
    const payload = {
        token,
        accept_invitation:true
    }
    postTokenData(payload,"post" )

  }
  return (
    <div className="account-page">
      <div className="main-wrapper">
        
        <div className="account-content">
          <div className="container">
            <div className="account-logo">
              <Link to="/app/main/dashboard">
                <img src={"https://storage.mealtrackr.io/internal/Nandos-Logo.png"} alt="Dreamguy's Technologies" />
              </Link>
            </div>
            <div className="account-box">
              <div className="account-wrapper">
                <h3 className="account-title">ESS Invitation</h3>
                {/* <p className="account-subtitle">
                  Enter your email to get a password reset link
                </p> */}
                {
                    userData?.require_password_set ?
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-3">
                            <label className="form-label">Full Name</label>
                            <input
                            readOnly
                            value={userData?.user?.first_name+" "+ userData?.user?.last_name}
                            className={`form-control `}
                            // placeholder="Enter new password"

                            />
                            <div className="invalid-feedback">{errors.password?.message}</div>
                        </div>
                        {/* Password Field */}
                        <div className="mb-3">
                            <label className="form-label">New Password</label>
                            <input
                            type="password"
                            className={`form-control ${errors.password ? "is-invalid" : ""}`}
                            placeholder="Enter new password"
                            {...register("password")}
                            />
                            <div className="invalid-feedback">{errors.password?.message}</div>
                        </div>

                        {/* Confirm Password Field */}
                        <div className="mb-3">
                            <label className="form-label">Confirm Password</label>
                            <input
                            type="password"
                            className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                            placeholder="Re-enter new password"
                            {...register("confirmPassword")}
                            />
                            <div className="invalid-feedback">{errors.confirmPassword?.message}</div>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Reset Password"}
                        </button>
                        </form>
                        :
                        <form onSubmit={acceptInvitation}>
                        <div className="mb-3">
                            <label className="form-label">Full Name</label>
                            <input
                            readOnly
                            value={userData?.user?.first_name+" "+ userData?.user?.last_name}
                            className={`form-control `}
                            // placeholder="Enter new password"

                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Email</label>
                            <input
                            readOnly
                            value={userData?.user?.email}
                            className={`form-control `}
                            // placeholder="Enter new password"

                            />
                        </div>
                       
                        {/* Submit Button */}
                        <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                            {isSubmitting ? "Submitting..." : "Accept"}
                        </button>
                        </form>
                }
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ResetPassword;
